import { ref, type Ref } from 'vue'

const STORAGE_KEY = 'debugTools_zoom_join_any_time'

let enabledRef: Ref<boolean> | null = null

/**
 * Dev-only: allow joining Zoom regardless of the normal time window
 * (class: 15 min before start – class end; consultation: 15 min before start –
 * scheduled end). Shared ref so toggling in DevTools immediately re-runs
 * LiveClassPage / consultation hub join gating.
 */
export function useZoomJoinAnyTimeDebug(): {
  zoomJoinAnyTimeEnabled: Ref<boolean>
  toggleZoomJoinAnyTime: () => void
} {
  if (enabledRef === null) {
    enabledRef = ref(
      typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY) === 'true',
    )
  }

  function toggleZoomJoinAnyTime() {
    if (enabledRef) {
      enabledRef.value = !enabledRef.value
      localStorage.setItem(STORAGE_KEY, String(enabledRef.value))
    }
  }

  return {
    zoomJoinAnyTimeEnabled: enabledRef,
    toggleZoomJoinAnyTime,
  }
}
